import React, { useEffect, useState } from 'react'
import lottieFile from "../../../assets/lottie/Smoke.json"
import { getWidth } from '../../../utils/relativeSizes'
import _isNil from 'lodash/isNil'
import { calculateCoordinates } from '../utils';
import Lottie from 'react-lottie';
import { useSelector } from 'react-redux';
import { getSmoke } from '../../../store/selectors/ludoboardSelectors';
import { SOUND_KEYS } from '../constant';
import { playSound } from '../../../classes/sound';

function SmokeAnimation() {

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: lottieFile,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const smoke = useSelector(getSmoke)
  // const boardType = useSelector(getBoardType)

  useEffect(() => {
    if (!_isNil(smoke)) {
      playSound(SOUND_KEYS.TOKEN_KILL)
    }
  }, [smoke])

  if (_isNil(smoke)) {
    return null
  }
  const smokeCoordinates = calculateCoordinates(smoke.playerNumber, smoke.tokenPosition)

  return (
    <div
      style={{
        position: 'absolute',
        transform: `translate(${smokeCoordinates?.translateX}px, ${smokeCoordinates?.translateY}px)`,
        zIndex: 80,
      }}
    >
      <Lottie
        options={defaultOptions}
        eventListeners={[
          {
            eventName: 'complete',
            callback: () => {console.log("smoke animation completed")},
          },
        ]}
        style={{ height: getWidth(80), width: getWidth(80), zIndex: 80 }}
      />
    </div>
  )
}

export default SmokeAnimation
